import { render, staticRenderFns } from "./EmailBroadcastStatusChip.vue?vue&type=template&id=4d48759e"
import script from "./EmailBroadcastStatusChip.vue?vue&type=script&lang=js"
export * from "./EmailBroadcastStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports